import React, { useCallback, useEffect, useRef, useState } from 'react'
import {
    Col,
    Container,
    EmptyList,
    Modal,
    Row,
    Spinner,
    TopBar
} from 'components'
import { CSSTransition } from 'react-transition-group'
import { constants } from 'helpers'
import { useTranslation } from 'react-i18next'
import { SingleNotification } from './SingleNotification'
import { FullNotificationModal } from './FullNotificationModal'
import { useAppSelector, useBindDispatch } from 'hooks'
import { NotificationType } from 'storeTypes'
import { useSearchParams } from 'react-router-dom'

export const Notification = () => {
    const { t } = useTranslation()
    const [searchParams, setSearchParams] = useSearchParams()
    const notificationIdParam = searchParams.get('notification_id')
    const [animate, setAnimate] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [selectedNotification, setSelectedNotification] =
        useState<NotificationType | null>(null)
    const { markNotificationReadHandler } = useBindDispatch()
    const { notificationList, loading: isLoading } = useAppSelector(
        (state) => state.notifications
    )
    const nodeRef = useRef(null)

    useEffect(() => {
        setAnimate(true)
    }, [])

    const handleModalSelection = (notification: NotificationType) => {
        setShowModal(true)
        setSelectedNotification(notification)
        if (!notification.read_status) {
            markNotificationReadHandler(notification)
        }
    }

    const findNotification = useCallback(
        (notificationId: string) =>
            notificationList?.find(({ uuid }) => uuid === notificationId),
        [notificationList]
    )

    useEffect(() => {
        if (notificationIdParam) {
            const foundNotification = findNotification(notificationIdParam)
            if (foundNotification) {
                setSearchParams({})
                handleModalSelection(foundNotification)
            }
        }
    }, [notificationIdParam, notificationList.length])

    return (
        <>
            <CSSTransition
                unmountOnExit
                timeout={constants.ANIMATION_TIMEOUT}
                in={animate}
                classNames="generic"
                appear
                nodeRef={nodeRef}
            >
                <div>
                    <div className="sticky-header" id="sticky-header">
                        <Container>
                            <TopBar>{t('messages')}</TopBar>
                        </Container>
                    </div>
                    <div className="notification--body">
                        <div className="notification--container" ref={nodeRef}>
                            <Container>
                                <Row>
                                    <Col md={12}>
                                        {isLoading ? (
                                            <Spinner
                                                size={'90'}
                                                pageSpinner={true}
                                                fullscreen={true}
                                            />
                                        ) : (
                                            <div>
                                                {notificationList.length > 0 ? (
                                                    notificationList.map(
                                                        (notification) => (
                                                            <SingleNotification
                                                                notificationData={
                                                                    notification
                                                                }
                                                                onClick={() =>
                                                                    handleModalSelection(
                                                                        notification
                                                                    )
                                                                }
                                                                key={
                                                                    notification.id
                                                                }
                                                            >
                                                                {
                                                                    notification.message_fr
                                                                }
                                                            </SingleNotification>
                                                        )
                                                    )
                                                ) : (
                                                    <div className="notification--no-notification">
                                                        <EmptyList
                                                            message={t(
                                                                'noNotification'
                                                            )}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                    </div>
                </div>
            </CSSTransition>
            <Modal
                showModal={showModal}
                position="bottom"
                closeClickHandler={() => setShowModal(false)}
                showCloseIconBtn
            >
                <FullNotificationModal
                    notificationData={selectedNotification}
                />
            </Modal>
        </>
    )
}
